<script>
	import { lineDash } from "../palette.js";
	export let layout;
	export let hover = null;
	export let stacked = false;
</script>

{#each layout.areas as a}
	<path d={a.d} class="area" class:stacked style="--c:{a.color}" />
{/each}
{#each layout.lines as l}
	<path d={l.d} class="line" style="--c:{l.color}" stroke-dasharray={lineDash(l.idx)} />
{/each}
{#each layout.dots as d}
	<circle cx={d.x} cy={d.y} r={layout.dotRadius} class="dot" style="--c:{d.color}" />
{/each}
{#each layout.lines as l}
	{#if l.end && !(hover && hover.kind === "x" && hover.index === l.points.length - 1)}
		<circle cx={l.end.x} cy={l.end.y} r={layout.dotRadius} class="dot" style="--c:{l.color}" />
	{/if}
{/each}

<style>
	.line {
		fill: none;
		stroke: var(--c);
		stroke-width: 2.5;
		stroke-linejoin: round;
		stroke-linecap: round;
	}

	.area {
		fill: var(--c);
		fill-opacity: 0.12;
	}

	.area.stacked {
		fill-opacity: 0.35;
	}

	.dot {
		fill: var(--c);
		stroke: var(--_surface);
		stroke-width: 2;
	}
</style>
